import { ThemeColors } from "@/shared/themes/Theme.interface";

// StyleValues are the same as Project Theme colors!
export type StyleValues = Required<ThemeColors>;

export enum MediaType {
    IMAGE = "image",
    VIDEO = "video",
    IFRAME = "iframe",
}

export type StyleTextColor = {
    textColor: string;
};

export type StyleBackgroundColor = {
    backgroundColor: string;
};

export interface BlockBaseElement<BlockDataValue> {
    isHidden: boolean;
    data: BlockDataValue;
}

export type BlockText = {
    text: string;
};

export type BlockLink = {
    href: string;
    label: string;
};

export type BlockButton = {
    href: string;
    label: string;
};

export type BlockHeading = {
    text: string;
    tag: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
};

export type BaseFormatting = {
    maxWidth: "max-w-2xl" | "max-w-3xl" | "max-w-4xl" | "max-w-5xl" | "max-w-6xl" | "max-w-7xl";
    elementAlign: "mx-auto" | "ml-0";
    paddingTop: "pt-0" | "pt-4" | "pt-8" | "pt-16" | "pt-24 lg:pt-32";
    paddingBottom: "pb-0" | "pb-4" | "pb-8" | "pb-16" | "pb-24 lg:pb-32";
};

export type TextSize = "text-sm" | "text-base" | "text-lg" | "text-xl" | "text-2xl" | "text-3xl";
export type HeadingTextSize =
    | TextSize
    | "text-4xl"
    | "text-5xl"
    | "text-6xl"
    | "text-4xl sm:text-5xl";
export type TextAlign = "text-left" | "text-center";
export type JustifyContent = "justify-start" | "justify-center" | "justify-end";

export type BlockTestimonial = {
    text: string;
    personImageSrc: string;
    personName: string;
    personPosition: string;
};

export type BlockImage = {
    src: string;
};

export type BlockDescriptiveImage = {
    alt: string;
} & BlockImage;

export type BlockBackgroundImage = {
    transparency: number;
} & BlockImage;

export type BlockMedia = {
    mediaType?: MediaType;
    videoSrc?: string;
    videoAutoplay?: boolean;
    videoControls?: boolean;
    videoLoop?: boolean;
    iframeSrc?: string;
} & BlockDescriptiveImage;

export type BlockArrayItems<TItem> = {
    items: (TItem & { id: number })[];
};

export type BlockDataValue =
    | BlockLink
    | BlockButton
    | BlockHeading
    | BlockDescriptiveImage
    | BlockBackgroundImage
    | BlockMedia
    | BlockTestimonial
    | BlockArrayItems<unknown>
    | BlockText
    | Record<string, unknown>;

export interface PageBlock<T extends Record<string, BlockBaseElement<BlockDataValue>>> {
    id: number;
    webId: string;
    dataValues: T;
    styleValues: StyleValues;
}
